import { useEffect } from "react";

const SITE_NAME = "Wine Country VIP";

const setMeta = (selector: string, attributes: Record<string, string>) => {
  let element = document.head.querySelector<HTMLMetaElement>(selector);
  if (!element) {
    element = document.createElement("meta");
    document.head.append(element);
  }
  for (const [name, value] of Object.entries(attributes)) element.setAttribute(name, value);
};

export const usePageMetadata = (title: string, description: string, noIndex = false) => {
  useEffect(() => {
    document.title = `${title} | ${SITE_NAME}`;
    setMeta('meta[name="description"]', { name: "description", content: description });
    setMeta('meta[name="robots"]', { name: "robots", content: noIndex ? "noindex,nofollow" : "index,follow" });
    setMeta('meta[property="og:title"]', { property: "og:title", content: document.title });
    setMeta('meta[property="og:description"]', { property: "og:description", content: description });
    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.append(canonical);
    }
    canonical.href = `${window.location.origin}${window.location.pathname}`;
  }, [description, noIndex, title]);
};

export const StructuredData = () => {
  const data = {
    "@context": "https://schema.org",
    "@graph": [
      { "@type": "Organization", name: SITE_NAME },
      {
        "@type": "WebSite",
        name: SITE_NAME,
        url: `${window.location.origin}/`,
        potentialAction: {
          "@type": "SearchAction",
          target: `${window.location.origin}/explore?q={search_term_string}`,
          "query-input": "required name=search_term_string"
        }
      }
    ]
  };
  return <script type="application/ld+json">{JSON.stringify(data)}</script>;
};
